import { Box, Button, Checkbox, Container, FormControlLabel, Stack, Typography } from '@mui/material'
import { observer } from 'mobx-react'
import React from 'react'
import { Link } from 'react-router-dom'
import betaStore, { BETA_FEATURES_META, BetaFeature } from './betaStore'

const BetaPage: React.FC = observer(() => {
  const features = Object.values(BetaFeature)

  return (
    <Box component='main' sx={{ flexGrow: 1 }}>
      <Container maxWidth='sm' sx={{ py: 4 }}>
        <Stack spacing={3}>
          <Typography variant='h4' component='h1'>
            Beta features
          </Typography>

          <Stack spacing={1}>
            {features.map((feature) => {
              const meta = BETA_FEATURES_META[feature]
              const enabled = betaStore.isEnabled(feature)

              return (
                <FormControlLabel
                  key={feature}
                  control={<Checkbox checked={enabled} onChange={(e) => betaStore.toggle(feature, e.target.checked)} />}
                  label={meta.title}
                />
              )
            })}
          </Stack>

          <Box display='flex' justifyContent='flex-start'>
            <Button component={Link} to='/' variant='contained'>
              Back
            </Button>
          </Box>
        </Stack>
      </Container>
    </Box>
  )
})

export default BetaPage
